import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fleet-scoreboard',
  styleUrls: ['./fleet-scoreboard.component.css'],
  templateUrl: './fleet-scoreboard.component.html'
})
export class FleetScoreboardComponent implements OnInit {
  @Input() awayCompetition: number;
  @Input() awayFleet: string;
  @Input() awayTeamLogo: string;
  @Input() awayTieBreaker: number;
  @Input() competitionHeader: string;
  @Input() competitionProgress: string;
  currentProgress: number;
  hasCompetition: boolean;
  @Input() homeCompetition: number;
  @Input() homeFleet: string;
  @Input() homeTeamLogo: string;
  @Input() homeTieBreaker: number;
  isAwayFleetWinner: boolean;
  isHomeFleetWinner: boolean;
  isTie: boolean;
  @Input() showTieBreaker: boolean;
  @Input() winningFleet: string;

  constructor() {}

  ngOnInit() {
    this.isAwayFleetWinner = this.awayFleet === this.winningFleet;
    this.isHomeFleetWinner = this.homeFleet === this.winningFleet;
    this.isTie = this.winningFleet && this.winningFleet.toLowerCase() === 'tie';
    this.hasCompetition = this.awayFleet ? true : false;
    if (this.competitionProgress === 'In Progress') {
      this.currentProgress = 1;
    } else if (this.competitionProgress === 'Calculating') {
      this.currentProgress = 2;
    } else {
      this.currentProgress = 0;
    }
  }
}
